import React from 'react'
import { formatPrice } from 'shared-constants'
import { DATA_TEST_CLASS } from 'shared-constants/build/testIds'
import { Box, Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { type CURRENCY_ISO_CODE, SESSION_TYPE } from 'constants/common'
import { FONT_WEIGHT, FONT_SIZE, SPACE, COLOR_INTENT } from 'Theme'

interface SessionInfoProps {
  title: string
  price: string
  lengthInMinutes: number
  sessionType?: (typeof SESSION_TYPE)[keyof typeof SESSION_TYPE]
  displayPrice?: string
  promoCodeAmount?: number
  couponDiscountPrice?: {
    total: number
    currencyIsoCode: (typeof CURRENCY_ISO_CODE)[keyof typeof CURRENCY_ISO_CODE]
  }
}

export const SessionInfo: React.FC<SessionInfoProps> = ({
  title,
  price,
  displayPrice,
  lengthInMinutes,
  sessionType,
  promoCodeAmount,
  couponDiscountPrice,
}) => {
  const isCouponApplied = couponDiscountPrice?.total > 0

  return (
    <Flex
      flexDirection="column"
      data-test-class={DATA_TEST_CLASS.CLIENT_SESSION_INFO}
      gap={SPACE.PX_5}
    >
      <Text
        data-test-class={DATA_TEST_CLASS.CLIENT_SESSION_INFO_NAME}
        fontSize={FONT_SIZE.PX_16}
        fontWeight={FONT_WEIGHT.MEDIUM}
      >
        {title}
      </Text>
      <Text
        data-test-class={DATA_TEST_CLASS.CLIENT_SESSION_INFO_DETAIL}
        fontSize={FONT_SIZE.PX_12}
        color={COLOR_INTENT.SESSION_INFO.LENGTH}
      >
        {`${lengthInMinutes} minutes \u{b7} ${price}${
          displayPrice ? ` (approx. ${displayPrice})` : ''
        }`}
        {sessionType === SESSION_TYPE.GROUP && '/participant'}
      </Text>
      {(promoCodeAmount > 0 || isCouponApplied) && (
        <Box color={COLOR_INTENT.DISCOUNT.DISCOUNT_TEXT}>
          {promoCodeAmount > 0 && (
            <Text fontSize={FONT_SIZE.PX_12} color="inherit">
              Discount applied ({promoCodeAmount}%){isCouponApplied && ', '}
            </Text>
          )}
          {isCouponApplied && (
            <Text fontSize={FONT_SIZE.PX_12} color="inherit">
              Gift Card (-
              {formatPrice({
                price: couponDiscountPrice.total,
                currency: couponDiscountPrice.currencyIsoCode,
              })}
              )
            </Text>
          )}
        </Box>
      )}
    </Flex>
  )
}
